import React from 'react';
import { motion } from 'framer-motion';

// Bespoke icon entrance: a soft "pop / draw-in" with a gentle overshoot when the
// icon scrolls into view. Hover glow is handled globally in index.css. Touch and
// reduced-motion users get the icon immediately (Framer respects prefers-reduced-motion).
export const AnimatedIcon = ({ children, className = '', delay = 0 }) => (
  <motion.span
    className={`inline-flex ${className}`}
    initial={{ opacity: 0, scale: 0.55, y: 6 }}
    whileInView={{ opacity: 1, scale: 1, y: 0 }}
    viewport={{ once: true, margin: '-40px' }}
    transition={{ duration: 0.55, ease: [0.34, 1.56, 0.64, 1], delay }}
  >
    {children}
  </motion.span>
);

export default AnimatedIcon;
